<div class="box-off-canva" [ngClass]="{'open': this.openInfoMinValue}" (click)="closeOffCanvas()"></div>
<div class="offcanvas offcanvas-bottom" tabindex="-1" [ngClass]="{'show': this.openInfoMinValue}" style="height: fit-content; z-index: 120;" [ngStyle]="{'height': offCanvasHeight + 'px', 'z-index': 120}" #offCanva>
  <div class="header-info"tabindex="-1" [ngClass]="{'show': openInfoMinValue}"  (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd()">
    <div></div>
  </div>
  <div class="offcanvas-body">
    <div class="content-offCanva">
        <span class="title-offCanva">Valor mínimo</span>
        <span class="info-offCanva">O pedido mínimo é de <b>{{ this.company.configs.minValue | currency: 'BRL' }}</b> sem contar com a taxa de entrega.</span>
    </div>
    <div class="button-offCanva">
      <button class="button-confirm" (click)="addItem()">Adicionar Item</button>
      <button (click)="closeOffCanvas()">Ok, Entendi</button>
    </div>
  </div>
</div>